module.exports = __webpack_public_path__ + "static/media/vantr-white.9205278d.webp";